import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeUserOverviewCardProps } from "@/__mocks__/profile/overview";
import type { OnboardingVerifyInfoPageProps } from "@/ui/components/onboarding/OnboardingVerifyInfoPage";
import OnboardingVerifyInfoPage from "@/ui/components/onboarding/OnboardingVerifyInfoPage";
import { Box, ScreenContainer } from "@/ui/layout";
import { ColorToken, LayoutToken } from "@/ui/theme/tokens";

const StoryMeta: Meta<OnboardingVerifyInfoPageProps> = {
  title: "Components/Onboarding/Verify Info",
  component: OnboardingVerifyInfoPage,
  argTypes: {
    onNextPress: { action: "next button pressed" },
    proxyPatientProfileOverviews: { control: "object" },
    selfProfileOverview: { control: "object" },
  },
  args: {
    proxyPatientProfileOverviews: faker.helpers.multiple(
      () => fakeUserOverviewCardProps(),
      {
        count: faker.number.int({ max: 2, min: 1 }),
      },
    ),
    selfProfileOverview: fakeUserOverviewCardProps(),
  },
  render: (props) => (
    <ScreenContainer backgroundColor={ColorToken.Primary10} isScrollView>
      <Box
        paddingBottom={LayoutToken.OnboardingScreenHorizontalPadding}
        paddingHorizontal={LayoutToken.OnboardingScreenHorizontalPadding}
        paddingTop={LayoutToken.OnboardingScreenTopPadding}
      >
        <OnboardingVerifyInfoPage {...props} />
      </Box>
    </ScreenContainer>
  ),
};

type Story = StoryObj<OnboardingVerifyInfoPageProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
